module.exports = __webpack_public_path__ + "img/default.b0242d41.gif";